import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import UpdateEmpPersonalInfoForm from "./UpdatePresonalInfoForm";

interface ModalProps {
  EmpNo: string;
  modal: boolean;
  toggle?: () => void;
}

const UpdateEmpPersonalInfoModal: React.FC<ModalProps> = ({
  EmpNo,
  modal,
  toggle,
}) => {
  return (
    <>
      <Modal
        size="xl"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="large-modal-header border-0">
            <H3>Update Employee Personal Information</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P>
              Review and update the applicant's personal details to ensure all
              information is accurate and complete.
            </P>
          </ModalHeader>
          <UpdateEmpPersonalInfoForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UpdateEmpPersonalInfoModal;
